import withRouter from '@common/withRouter'
import { IRouterProps } from "@Interface/Login";
import FailureImage from "@assets/images/mission-center/chicken-failed.png";
import React from "react";
import Button from "@components/Button";
import { t } from "@utils/translations";

const FailurePopup: React.FC<IRouterProps & { question: string; onClose: () => void }> = ({ question, onClose }) => {
    return (
        <div
            className="fixed left-1/2 top-0 z-50 flex h-dvh min-h-dvh w-full -translate-x-1/2 flex-col overflow-hidden bg-white p-3 tracking-[2%]"
        >
            <div
                className="mx-auto flex min-h-0 w-full flex-1 flex-col items-center justify-evenly overflow-y-auto overscroll-contain px-4 text-center gap-2"
            >
                <h1 className="w-full shrink-0 text-xl font-bold leading-snug text-(--dark-gray)">
                    <span className="block">{question}</span>
                </h1>

                <div
                    className="flex w-full shrink-0 justify-center"
                    role="img"
                    aria-label="Failure Image"
                >
                    <img
                        src={FailureImage}
                        alt="Failure Image"
                        className="size-70 object-contain"
                    />
                </div>

                <div className="flex shrink-0 flex-col items-center gap-2">
                    <p className="text-2xl font-bold text-(--button-green)">再想一想！</p>
                    <p className="px-1 text-sm leading-normal text-(--dark-gray)">這個答案不太對，再想一想</p>
                    <p className="px-1 text-sm leading-normal text-(--dark-gray)">吧！</p>
                </div>

                {/* <div className="w-[70%] shrink-0 rounded-xl border border-(--button-green) bg-[#E8FFF2] px-4 py-3 text-center">
                    <h3 className="text-lg font-semibold text-(--button-green)">小提示</h3>
                    <p className="mt-1.5 text-base leading-relaxed text-(--dark-gray)">
                        新思考一下，看看就在你編碼時！
                    </p>
                </div> */}

                <div className="w-[70%] shrink-0">
                    <Button label={t('quiz.ReturnToTask')} onClick={onClose} classNames="py-3 font-bold text-sm" />
                </div>
            </div>
        </div>
    )
}

export default withRouter(FailurePopup);